import { Component, OnDestroy, OnInit, inject } from "@angular/core";
import { NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { Subscription } from "rxjs";
import { ga4PageView } from "./ga4";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [RouterOutlet],
  template: `<router-outlet />`,
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly router = inject(Router);
  private sub?: Subscription;

  ngOnInit(): void {
    this.sub = this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) return;
      ga4PageView(evt.urlAfterRedirects);
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
